<template>
  <nav class="navbar is-link is-fixed-top" role="navigation" aria-label="main navigation">
  <div class="navbar-brand  is-2">
    <a href="/" class="navbar-item " >
      <img src="@/assets/oneills_logo_white_2023_small.png" srcset="@/assets/oneills_logo_white_2023_small@2x.png 2x" width="112" height="28">
    </a>

    <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" @click="isOpen = !isOpen" v-bind:class="{'is-active': isOpen}">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicExample" class="navbar-menu " v-bind:class="{'is-active': isOpen}">
    <div class="navbar-start">
        <div v-if="1===2">
      	<router-link class="navbar-item" v-if="!$auth.loading && $auth.isAuthenticated && $auth.user.roles.includes('sales')" to="/orders">Orders</router-link>
      	<router-link class="navbar-item" v-if="!$auth.loading && $auth.isAuthenticated && $auth.user.roles.includes('admin')" to="/admin">Admin</router-link>
      	<router-link class="navbar-item"  to="/orders"><a  class="button is-danger">Sales</a></router-link>
      	<router-link class="navbar-item"  to="/orders"><a  class="button is-success">Production</a></router-link>
      	<router-link class="navbar-item"  to="/orders"><a  class="button is-warning">Design</a></router-link>
        </div>
      </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div class="buttons">
          
          <div v-if="!$auth.loading">
	        
	        
	        <!-- show login when not authenticated -->
	        <a v-if="!$auth.isAuthenticated" @click="login" class="button is-dark is-hidden is-small"><strong>Sign in</strong></a>
	        <!-- show logout when authenticated -->
	        <a v-if="$auth.isAuthenticated"  class="button is-dark is-small" :href="ASP_SYSTEM_URL + '/index.php?MODE=LOGOUTAPP'"><strong>Log out</strong></a>
	      </div>
        </div>
      </div>
    </div>
  </div>
</nav>
</template>
<script>
export default {
  name: 'nav-bar',
  components: {
  },
  methods: {
	  // Log the user in
	  login() {
	    this.$auth.loginWithRedirect();
	  },
	  // Log the user out
	  logout() {
	    this.$auth.logout({
	      returnTo: window.location.origin
	    });
	  }
  },
   data: function() {
        return {
            isOpen: false,
            ASP_SYSTEM_URL: process.env.VUE_APP_ASP_URL
        }
    },
    watch: {
	    '$route' () {
	      this.isOpen=false;
	    }
    },
    
}
</script>